import moment, { Moment } from "moment";
import React, { useEffect, useState } from "react";

import { Spinner } from "src/shared/components";

import { useMentorShiftsQuery } from "../../shifts/graphql/mentorShifts.generated";
import { Calendar } from "../calendar/Calendar";
import { TMentorShiftScheduleEvent } from "../constants";
import { TMentorShiftSchedule, TIsRegistered, TIsDisabled } from "../types";
import { blocksFromTop, sortComputedShifts } from "../utils";

interface CalenderViewScheduleProps {
  fetchingShifts: boolean;
  mentorShifts: TMentorShiftSchedule[];
  isRegistered: TIsRegistered[];
  isDisableRegistered: TIsDisabled[];
  handleRegister: (shiftId: number, index: number, spotsLeft: number) => void;
  handleUnregister: (shiftId: number, index: number, spotsLeft: number) => void;
  setSelectedShift: (shiftId: number) => void;
  setViewModal: (visible: boolean) => void;
}

const MentorShiftCalendarView: React.FC<CalenderViewScheduleProps> = ({
  fetchingShifts,
  mentorShifts,
  isRegistered,
  isDisableRegistered,
  handleRegister,
  handleUnregister,
  setSelectedShift,
  setViewModal,
}) => {
  const [calendarShifts, setCalendarShifts] = useState<
    TMentorShiftScheduleEvent[]
  >([]);

  const handleShiftClick = (shift_id: number) => {
    setSelectedShift(shift_id);
    setViewModal(true);
  };

  const {
    data: mentorShiftData,
    error: shiftError,
    loading: shiftLoading,
  } = useMentorShiftsQuery({
    variables: {
      where: {},
    },
  });

  const convertToScheduleShift = (
    shift: TMentorShiftSchedule,
    momentStart: Moment,
    momentEnd: Moment,
    registered: number,
    max: number,
    isRegistered: TIsRegistered,
    isDisableRegistered: TIsDisabled
  ): TMentorShiftScheduleEvent => {
    const blocks = moment.duration(momentEnd.diff(momentStart)).asHours();

    return {
      id: shift.shift_id,
      title: shift.shift,
      start: momentStart,
      end: momentEnd,
      displayedStart: momentStart.format("HH:mm"),
      displayedEnd: momentEnd.format("HH:mm"),
      numberOfBlocks: blocks,
      blocksFromTop: blocksFromTop(momentStart),
      overlapColumn: 0,
      registeredMentors: registered,
      maxMentors: max,
      isRegistered: isRegistered,
      isDisableRegistered: isDisableRegistered,
    };
  };

  useEffect(() => {
    const computedShifts: TMentorShiftScheduleEvent[] = [];

    const fetching = fetchingShifts;

    if (!fetching) {
      mentorShifts.forEach((shift, index) => {
        const momentStart = moment(shift.time_start).tz("America/New_York");
        const momentEnd = moment(shift.time_end).tz("America/New_York");

        computedShifts.push(
          convertToScheduleShift(
            shift,
            momentStart,
            momentEnd,
            shift.required_mentors - shift.spots_left,
            shift.required_mentors,
            isRegistered[index],
            isDisableRegistered[index]
          )
        );
      });

      sortComputedShifts(computedShifts);
      setCalendarShifts(computedShifts);
    }
  }, [
    fetchingShifts,
    mentorShifts,
    mentorShiftData,
    shiftError,
    shiftLoading,
    isDisableRegistered,
    isRegistered,
  ]);

  return (
    <>
      {fetchingShifts ? (
        <Spinner text="Loading shifts..." />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "60vh",
          }}
        >
          <Calendar
            daysToShow={["2026-09-18", "2026-09-19", "2026-09-20"]}
            calendarShifts={calendarShifts}
            setSelectedShift={handleShiftClick}
            isAdmin={false}
            handleRegister={handleRegister}
            handleUnregister={handleUnregister}
          />
        </div>
      )}
    </>
  );
};

export default MentorShiftCalendarView;
